module.exports = __webpack_public_path__ + "static/media/Clock-grad.b2e221d6.png";